import { mapState } from 'vuex'
import track from '../../../components/track'

export default {
    props: {
        index: {
            type: Number,
            default: 0
        },
    },

    data() {
        return {
            loading: {
                global: false,
                check: false,
                provinces: false,
                municipalities: false,
                entities: false,
            },
            // notify: true,
            status: null,
            address: null,
            addressHasError: false,
            gis: {
                provinces: [],
                municipalities: [],
                entities: [],
            },
            form: {
                province: null,
                provinceHasError: false,
                municipality: null,
                municipalityHasError: false,
                entity: null,
                entityHasError: false,
                street: null,
                streetHasError: false,
                number: null,
                numberHasError: false,
            },
        }
    },

    watch: {
    //     notify: function(newNumber) {
    //         this.$emit('config', this.getAddressData())
    //     },
        showStepErrors: function(show) {
            if(show) {
                this.form.provinceHasError = !this.validateProvince()
                this.form.municipalityHasError = !this.validateMunicipality()
                this.form.entityHasError = !this.validateEntity()
                this.form.streetHasError = !this.validateStreet()
                this.form.numberHasError = !this.validateNumber()
                this.addressHasError = !this.validateStatus()
            } else {
                this.form.provinceHasError    = false
                this.form.municipalityHasError = false
                this.form.entityHasError = false
                this.form.streetHasError = false
                this.form.numberHasError = false
                this.addressHasError = false
            }
        }
    },

    created() {
        this.populateProvinces()
    },

    mounted() {
        this.emitConfig()
    },

    methods: {

        async populateProvinces() {
            this.loading.global = true
            this.loading.provinces = true
            this.gis.provinces = await this.fetchProvinces()
            this.loading.provinces = false
            this.loading.global = false
        },

        async populateMunicipalities() {
            this.loading.global = true
            this.loading.municipalities = true
            this.gis.municipalities = await this.fetchMunicipalities()
            this.loading.municipalities = false
            this.loading.global = false
        },

        async populateEntities() {
            this.loading.global = true
            this.loading.entities = true
            this.gis.entities = await this.fetchEntities()
            this.loading.entities = false
            this.loading.global = false
        },

        async fetchProvinces() {
            try {
                let res = await axios.post('/coverage/search', {
                    type: 'pro'
                })

                return res.data?.data ?? []

            } catch (e) {
                console.error(e.message)
                return []
            }
        },

        async fetchMunicipalities() {
            try {
                let res = await axios.post('/coverage/search', {
                    type: 'mun',
                    pc: this.form.province.c
                })

                return res.data?.data ?? []

            } catch (e) {
                console.error(e.message)
                return []
            }
        },

        async fetchEntities() {
            try {
                let res = await axios.post('/coverage/search', {
                    type: 'ent',
                    mc: this.form.municipality.c
                })

                return res.data?.data ?? []

            } catch (e) {
                console.error(e.message)
                return []
            }
        },

        shouldCheck() {
            // skip if we already have a status result
            if(this.status) return
            this.check()
        },


        async check() {
            if(!this.canSearch) return
            this.status = null
            this.loading.global = true
            this.loading.check = true

            try {
                let params = {
                    entity_code: this.form.entity.c,
                    entity_level: this.form.entity.l,
                    street_name: this.form.street,
                    number_name: this.form.number,
                }

                let res = await axios.post('/coverage/check', params)
                this.status = res.data.data?.status ?? null
                this.address = res.data.data?.address ?? null
                this.trackCheckEvent()
            } catch (e) {
                console.group('check error')
                console.log("error", e.message)
                console.log("response error", e.response?.data?.message ?? e)
                console.groupEnd()
                this.trackCheckEvent(e.response?.data?.message ?? e.message ?? 'ERROR')
            } finally {
                this.loading.check = false
                this.loading.global = false
                this.emitConfig()
            }

        },

        trackCheckEvent(message = null) {
            track.event({
                eventCategory: "orders",
                eventAction: "check-coverage",
                eventLabel: message ?? this.getTrackingLabel()
            })
        },

        getTrackingLabel() {
            let status = this.status ?? 'UNKNOWN'
            let municipality = this.address?.municipality_name ?? 'UNKNOWN'

            return `${status}-[${municipality}]`
        },

        provinceChange() {
            if(this.showStepErrors) this.form.provinceHasError = !this.validateProvince()
            this.resetMunicipalities()
            this.populateMunicipalities()
            this.emitConfig()
        },

        municipalityChange() {
            if(this.showStepErrors) this.form.municipalityHasError = !this.validateMunicipality()
            this.resetEntities()
            this.populateEntities()
            this.emitConfig()
        },

        entityChange() {
            if(this.showStepErrors) this.form.entityHasError = !this.validateEntity()
            this.resetStreets()
            this.emitConfig()
        },

        streetChange() {
            if(this.showStepErrors) this.form.streetHasError = !this.validateStreet()
            this.resetNumbers()
            this.emitConfig()
        },

        numberChange() {
            if(this.form.number === '0') this.form.number = 'S/N'
            if(this.showStepErrors) this.form.numberHasError = !this.validateNumber()
            this.resetResult()
            this.emitConfig()
        },

        resetMunicipalities() {
            this.gis.municipalities = []
            this.form.municipality = null
            this.form.municipalityHasError = false
            this.resetEntities()
        },

        resetEntities() {
            this.gis.entities = []
            this.form.entity = null
            this.form.entityHasError = false
            this.resetStreets()
        },

        resetStreets() {
            this.form.street = null
            this.form.streetHasError = false
            this.resetNumbers()
        },

        resetNumbers() {
            this.form.number = null
            this.form.numberHasError = false
            this.resetResult()
        },

        resetResult() {
            this.status = null
            this.address = null
            this.addressHasError = false
            // this.notify = true
        },

        getAddressData() {
            return Object.assign({}, {
                // notify: this.notify,
                coverage: this.status,
                valid: this.validate(),
                province_code: null,
                province_name: null,
                region_code: null,
                region_name: null,
                municipality_code: null,
                municipality_name: null,
                entity_code: null,
                entity_level: null,
                entity_name: null,
                postal_code: null,
                postal_name: null,
                street_code: null,
                street_name: null,
                number_code: null,
                number_name: null,
            }, this.address)
        },

        emitConfig() {
            this.$emit('config', this.getAddressData())
        },

        validate() {
            if(!this.address) return false
            if(!this.validateProvince()) return false
            if(!this.validateMunicipality()) return false
            if(!this.validateEntity()) return false
            if(!this.validateStreet()) return false
            if(!this.validateNumber()) return false
            if(!this.validateStatus()) return false

            return true
        },

        validateProvince() {
            return !!this.form.province;
        },

        validateMunicipality() {
            return !!this.form.municipality;
        },

        validateEntity() {
            return !!this.form.entity
        },

        validateStreet() {
            if(!this.form.street) return false
            return !(this.form.street.length < 3 || this.form.street.length > 50);
        },

        validateNumber() {
            if(!this.form.number) return false
            return !(this.form.number.length < 1 || this.form.number.length > 8);
        },

        validateStatus() {
            return !(!this.status
                || this.status.length === 0
                || !['unavailable', 'available', 'forecast', 'review'].includes(this.status));

        }
    },

    computed: {

        ...mapState('steps', {
            showStepErrors: state => state.one.showErrors,
        }),

        canSearch() {
            if(!this.form.province) return false
            if(!this.form.municipality) return false
            if(!this.form.entity) return false
            if(!this.form.street) return false
            if(!this.form.number) return false
            return true
        },

        statusLoading() {
            return this.status === null
        },

        statusChecking() {
            return !this.status && this.loading.check
        },

        statusUnavailable() {
            return this.status === 'unavailable'
        },

        statusAvailable() {
            return this.status === 'available'
        },

        statusForecast() {
            return this.status === 'forecast'
        },

        statusReview() {
            return this.status === 'review'
        },

        isNotValid() {
            return !this.validate()
        },

        municipalityDisabled() {
            return !this.form.province
                || this.gis.municipalities.length === 0
        },

        entityDisabled() {
            return !this.form.municipality
                || this.gis.entities.length === 0
        },

        streetDisabled() {
            return !this.form.entity
        },

        numberDisabled() {
            return !this.form.street
        }
    }
}
